import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Transaction } from '../../models/transaction';
import { BaseService } from '../base/base.service';

@Injectable()
export class TransactionDataService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    public createTransaction(transaction: Transaction): Observable<Transaction> {
        const apiUrl = `${environment.apiUrl}/Transaction/Create`;

        this.setHttpOptions();

        return this.http.post<any>(apiUrl, JSON.stringify(transaction), this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    public getTransaction(transactionId: string): Observable<Transaction> {
        let apiUrl = `${environment.apiUrl}/Transaction`;

        if (environment.mockData) {
            apiUrl = 'mock-data/transaction-status.json';
        }

        this.setHttpOptions();
        this.setHttpParam('transactionId', transactionId);

        return this.http.get<Transaction>(apiUrl, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    public getTransactionStatus(payUReference: string): Observable<Transaction> {
        let apiUrl = `${environment.apiUrl}/Transaction/Status`;

        if (environment.mockData) {
            apiUrl = 'mock-data/transaction-status.json';
        }

        this.setHttpOptions();
        this.setHttpParam('payUReference', payUReference);

        return this.http.get<Transaction>(apiUrl, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    public refundTransaction(payUReference: string): Observable<any> {
        const apiUrl = `${environment.apiUrl}/Transaction/Refund`;

        this.setHttpOptions();
        this.setHttpParam('payUReference', payUReference);
        
        return this.http.get<any>(apiUrl, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    public checkForPendingContractActivation(vin: string): Observable<any> {
        const apiUrl = `${environment.apiUrl}/Transaction/CheckForPendingContractActivation`;

        this.setHttpOptions();
        this.setHttpParam('vin', vin);

        return this.http.get<any>(apiUrl, this.httpOptions)
            .pipe(catchError(this.handleError));
    }
}
